import React from 'react'

function Footer() {
    return (
        <div className='footer'>
            <small>Copyright ©2022 Ritesh Hajare</small>
        </div>
    )
}

export default Footer